import { AppServices } from '@singularsystems/neo-core';
import UsersApiClient from './ApiClients/UsersApiClient';
import { AccessControlTypes } from './AccessControlTypes';

export const AccessControlAppModule = new AppServices.Module("AccessControl", container => {

    // Api Clients
    container.bind(AccessControlTypes.ApiClients.UsersApiClient).to(UsersApiClient).inSingletonScope();
    // Services
});

export const AccessControlTestModule = new AppServices.Module("AccessControl", container => {
    // bind test types
});